import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserAuthService } from 'src/app/auth/services/user-auth.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { ApiUtilsService } from '../services/api-utils.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private userStateService: UserStateService,
    private apiUtilsService: ApiUtilsService,
    private injector: Injector,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const sendsToken =
      this.apiUtilsService.isAuthorizedEndpoint(req.url) &&
      !!this.userStateService.getAccessToken();
    const handled: Observable<HttpEvent<any>> = sendsToken
      ? next.handle(
          req.clone({
            headers: req.headers.append(
              'Authorization',
              'Bearer ' + this.userStateService.getAccessToken().access_token,
            ),
          }),
        )
      : next.handle(req);

    return handled.pipe(
      catchError((err) => {
        if (
          err instanceof HttpErrorResponse &&
          err.status === 401 &&
          sendsToken &&
          this.userStateService.isRiseAuthUser()
        ) {
          this.injector.get(UserAuthService).signOut();
        }
        return throwError(() => err);
      }),
    );
  }
}
